import { useEffect, useRef } from "react";

/** Intervalo de auto-refresh de las vistas de monitoreo en vivo (CP-570). */
export const LIVE_INTERVAL_MS = 30_000;

/**
 * setInterval que no dispara con la pestaña oculta y refresca una vez al volver
 * a verse. Evita que los tabs de fondo sumen carga 24×7 a la API (CP-570).
 * `fn` puede cambiar entre renders sin reiniciar el intervalo.
 */
export function useVisibleInterval(fn: () => unknown, ms: number, enabled = true): void {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    if (!enabled) return;
    const tick = () => { if (document.visibilityState === "visible") void fnRef.current(); };
    const id = setInterval(tick, ms);
    document.addEventListener("visibilitychange", tick);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", tick); };
  }, [ms, enabled]);
}
